import echarts from "./echartsCore";

const readToken = (name, fallback) => {
  if (typeof window === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return v || fallback;
};

export const buildRdcTheme = () => {
  const textPrimary = readToken("--rdc-text-primary", "#0f172a");
  const textSecondary = readToken("--rdc-text-secondary", "#475569");
  const textMuted = readToken("--rdc-chart-axis-label", "#64748b");
  const grid = readToken("--rdc-chart-grid", "#eef1f6");
  const axis = readToken("--rdc-chart-axis", "#cbd2dd");
  const tooltipBg = readToken("--rdc-chart-tooltip-bg", "#0f172a");
  const tooltipFg = readToken("--rdc-chart-tooltip-fg", "#f8fafc");
  const fontFamily =
    readToken("--rdc-font-display", "'IBM Plex Sans', system-ui, sans-serif");

  return {
    color: [
      readToken("--rdc-cat-1", "#0e578e"),
      readToken("--rdc-cat-2", "#0284c7"),
      readToken("--rdc-cat-3", "#16a34a"),
      readToken("--rdc-cat-4", "#d97706"),
      readToken("--rdc-cat-5", "#dc2626"),
      readToken("--rdc-cat-6", "#7c3aed"),
      readToken("--rdc-cat-7", "#db2777"),
      readToken("--rdc-cat-8", "#0891b2"),
    ],
    backgroundColor: "transparent",
    textStyle: {
      fontFamily,
      color: textSecondary,
    },
    title: {
      textStyle: { color: textPrimary, fontWeight: 600 },
      subtextStyle: { color: textMuted },
    },
    grid: {
      left: 12,
      right: 12,
      top: 16,
      bottom: 24,
      containLabel: true,
    },
    categoryAxis: {
      axisLine: { show: true, lineStyle: { color: axis } },
      axisTick: { show: false },
      axisLabel: {
        color: textMuted,
        fontSize: 11,
        fontFamily,
        margin: 12,
      },
      splitLine: { show: false },
      splitArea: { show: false },
    },
    valueAxis: {
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        color: textMuted,
        fontSize: 11,
        fontFamily,
        margin: 12,
      },
      splitLine: {
        show: true,
        lineStyle: { color: grid, type: "solid" },
      },
      splitArea: { show: false },
    },
    legend: { show: false },
    tooltip: {
      backgroundColor: tooltipBg,
      borderColor: "transparent",
      borderRadius: 10,
      padding: [10, 12],
      textStyle: {
        color: tooltipFg,
        fontFamily,
        fontSize: 12,
      },
      extraCssText:
        "box-shadow: 0 12px 32px -8px rgba(15,23,42,.25); backdrop-filter: blur(4px);",
      axisPointer: {
        type: "shadow",
        shadowStyle: { color: "rgba(14,87,142,.06)" },
      },
    },
    bar: {
      itemStyle: { borderRadius: [4, 4, 0, 0] },
    },
  };
};

let registered = false;

export const ensureTheme = () => {
  if (registered) return "rdc";
  echarts.registerTheme("rdc", buildRdcTheme());
  registered = true;
  return "rdc";
};

export const refreshTheme = () => {
  registered = false;
  return ensureTheme();
};
